import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TCEmbeddedModeService {
  private _isEmbedded$ = new BehaviorSubject<boolean>(false);
  readonly isEmbedded$ = this._isEmbedded$.asObservable();

  init(): void {
    const currentPath = window.location.href;
    this._isEmbedded$.next(currentPath.includes('/embedded-mode'));
  }

  isEmbedded(): boolean {
    return this._isEmbedded$.value;
  }
}
